import { compact, uniqBy } from 'lodash'

import { AddressDisplay } from '~/components/component-library'
import { UserDisplay } from '~/components/component-library/UserDisplay'
import {
  BackendSmartAccount,
  BackendTransaction,
  OrgEOASigner,
  OrgMember,
  OrgSigner,
} from '~/types'
import { IAddress } from '~/types'

export const TransactionApprovers = ({
  transaction,
  smartAccount,
}: {
  transaction: BackendTransaction
  smartAccount: BackendSmartAccount
}) => {
  const passkeySignerIds = transaction.signers.map((signer) => signer.id)
  const eoaApprovals = transaction.eoaSigners
    .map((signer: OrgEOASigner) => signer.address)
    .filter(Boolean)

  const passkeySignersRemaining = uniqBy(
    compact(
      smartAccount.signers
        .filter((signer: OrgSigner) => !passkeySignerIds.includes(signer.id))
        .map((signer: OrgSigner) => signer.user),
    ),
    'id',
  )
  const eoaSignersRemaining = smartAccount.eoaSigners
    .filter((signer: OrgEOASigner) => !eoaApprovals.includes(signer.address))
    .map((signer: OrgEOASigner) => signer.address)
    .filter(Boolean)

  return (
    <div className="flex flex-col gap-1.5">
      <span className="text-sm text-secondary">
        {passkeySignersRemaining.length > 0 ? 'Members' : 'Accounts'} who can
        approve
      </span>
      {passkeySignersRemaining.map((user, index: number) => (
        <UserDisplay
          key={`signer-${index}`}
          user={user as OrgMember}
          layout="standard"
          size="small"
          hidePopover
        />
      ))}
      {eoaSignersRemaining.map((signer, index: number) => (
        <AddressDisplay
          key={`signer-${index}`}
          address={signer as IAddress}
          layout="standard"
          size="small"
        />
      ))}
    </div>
  )
}
